/* global wasm_bindgen */
import { MoleculeConverter } from '@moleculeone/molecule-utils';
import { setPositions } from '@moleculeone/draw';

import {
  ConversionMolToSmilesError,
  ConversionReactionToRxnError,
  ConversionSmilesToMolError,
  ConversionMolfileToMolError,
} from '@f/error-decorators/errors/conversion';
import { MolfileParsingError } from '@f/error-decorators/errors/parsing';
import { calculateSeededPositions } from '@f/utils/mol';

const moleculeConverter = new MoleculeConverter({ ...wasm_bindgen });

export async function smilesToMol(smiles, params = {}) {
  try {
    const mol = await moleculeConverter.smilesToMol(smiles, params);
    return setPositions(
      mol,
      calculateSeededPositions({
        mol,
        seedId: smiles,
      })
    );
  } catch (error) {
    console.error('Failed to convert SMILES to mol: %s', error.stack);
    throw new ConversionSmilesToMolError({ errors: [error] });
  }
}

export async function molfileToMol(molfile, params = {}) {
  try {
    const mol = await moleculeConverter.molfileToMol(molfile, params);
    return setPositions(
      mol,
      calculateSeededPositions({
        mol,
        seedId: molfile,
      })
    );
  } catch (error) {
    console.error('Failed to convert molfile to mol: %s', error.stack);

    if (error.uncaught) {
      throw new ConversionMolfileToMolError({ errors: [error] });
    }

    throw new MolfileParsingError(error);
  }
}

export async function molToSmiles(mol) {
  if (!mol) {
    return '';
  }
  try {
    return moleculeConverter.molToSmiles(mol);
  } catch (error) {
    console.error('Failed to convert mol to SMILES: %s', error.stack);
    throw new ConversionMolToSmilesError({ errors: [error] });
  }
}

export async function molToMolfile(mol) {
  try {
    return moleculeConverter.molToMolfile(mol);
  } catch (error) {
    console.error('Failed to convert mol to molfile: %s', error.stack);
    throw new Error('Cannot JSON.stringify mol');
  }
}

export async function reactionToRxn({ productSmiles, substrateSmiles = [] }) {
  try {
    return moleculeConverter.reactionToRxn({ productSmiles, substrateSmiles });
  } catch (error) {
    console.error('Failed to convert reaction data to RXN: %s', error.stack);
    throw new ConversionReactionToRxnError({ errors: [error] });
  }
}
